import { Component } from '@angular/core';

@Component({
  selector: 'app-ef-data',
  templateUrl: './ef-data.component.html',
  styleUrls: ['./ef-data.component.css']
})
export class EFDataComponent {
  async loadReadOnlyCakeTopology(_efateSetupPk?: number, _groupKey?: string): Promise<void> {
    return;
  }
}